export default class LicenseBorrowingAndReturning {
  // 获取部门
  static getProjectList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/listByDatasourceId/oaFormProjectInfo', 'post', data, axiosOption, httpOption);
  }
  static getPeopleList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/sysUser/list', 'post', data, axiosOption, httpOption);
  }
    
  static getList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/listByDatasourceId/oaFormLicenseBorrowtest', 'post', data, axiosOption, httpOption);
  }
  static createdBorrow (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/addDatasource/oaFormLicenseBorrowtest', 'post', data, axiosOption, httpOption);
  }
  static updateBorrow (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/updateDatasource/oaFormLicenseBorrowtest', 'post', data, axiosOption, httpOption);
  }
    
  static deleteBorrow (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/deleteDatasource/oaFormLicenseBorrowtest', 'post', data, axiosOption, httpOption);
  }
}
